<template>
  <div class="tab-content">
    <div class="main-content">
      <ValidationObserver ref="formValidator" v-slot="{ dirty }">
        <SaveObserver name="saveObserverPeiTab9" :dirty="dirty">
          <form
            id="modal-form"
            ref="form"
            class="needs-validation"
            novalidate
            @submit.prevent="handleSubmitFake"
          >
            <SectionTitle
              v-if="!isPs && !isPSC"
              :is-big-icon="true"
              icon="fas fa-users"
              content="IX. Participación de la familia y otras agencias"
              container-class="tag-badge-main-info mt-5 mb-4"
            />

            <Error
              v-if="controversyIX && controversyIX.existControversy"
              is-alert-mode
              :message="
                '<b>Parte en Controversia: </b>' +
                  controversyIX.informationMessage
              "
            />

            <SectionTitle
              v-if="!isPs && !isPSC"
              :has-line="true"
              content="A. Describa la participación de otras agencias en la provisión de servicios recomendados para el estudiante"
              container-class="mb-4"
            />
            <div v-if="!isPs && !isPSC" class="col-12 pl-0 pr-0">
              <Error v-if="errorMessage" :message="errorMessage" />
              <div class="container-table-striped">
                <div class="table-hover">
                  <table class="table content-table-striped table-h">
                    <thead>
                      <tr class="row global-thead-dark thead-property">
                        <th class="col-3 pl-5 py-3">
                          <span class="text-bold">Agencia / Contacto</span>
                        </th>
                        <th class="col-3 py-3 text-bold">
                          Servicio
                        </th>
                        <th class="col-3 py-3 text-bold">
                          Invitación / Participación
                        </th>
                        <th class="col-3" />
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(agency, index) in agencies"
                        :key="index"
                        class="row"
                      >
                        <td class="col-md-3">
                          <div class="w-100 ml-3 td-row-space">
                            <ValidationProvider
                              v-slot="{ errors }"
                              :name="'selectedAgency' + index"
                              rules="required"
                            >
                              <CustomDropDown
                                v-model="agency.selectedAgency"
                                placeholder="Seleccionar Agencia"
                                required
                                :disabled="isReadonlyWithAmendment"
                                fieldkey="id"
                                fieldname="name"
                                :options="avaliableAgencyListComputed()"
                                :error="errors[0]"
                                :custom-error-msg="resources['9001']"
                                @input="changeAgency($event, agency)"
                              />
                            </ValidationProvider>
                          </div>
                          <div class="w-100 mt-3 ml-3 td-row-space">
                            <ValidationProvider
                              v-slot="{ errors }"
                              :name="'contactName' + index"
                              rules="required"
                            >
                              <CustomInput
                                v-model="agency.contactName"
                                label="Nombre Contacto"
                                placeholder="Escribir nombre"
                                :disabled="isReadonlyWithAmendment"
                                required
                                :error="errors[0]"
                                :custom-error-msg="resources['9002']"
                                @input="changeContactName($event, agency)"
                              />
                            </ValidationProvider>
                          </div>
                        </td>
                        <td class="col-md-3">
                          <div class="w-100 mt-0 ml-3 td-row-space">
                            <ValidationProvider
                              v-slot="{ errors }"
                              :name="'providedService' + index"
                              rules="required"
                            >
                              <CustomInput
                                v-model="agency.providedService"
                                label
                                placeholder="Escribir servicio provisto"
                                required
                                :disabled="isReadonlyWithAmendment"
                                :error="errors[0]"
                                :custom-error-msg="resources['9003']"
                              />
                            </ValidationProvider>
                          </div>
                          <div class="w-100 mt-3 ml-3 td-row-space">
                            <ValidationProvider
                              v-slot="{ errors }"
                              :name="'contactName' + index"
                              rules="required"
                            >
                              <CustomInput
                                v-model="agency.contactFirstLastName"
                                label="Primer Apellido Contacto"
                                placeholder="Escribir primer apellido"
                                :disabled="isReadonlyWithAmendment"
                                required
                                :error="errors[0]"
                                :custom-error-msg="resources['9009']"
                                @input="
                                  changeContactFirstLastName($event, agency)
                                "
                              />
                            </ValidationProvider>
                          </div>
                        </td>
                        <td class="col-md-3">
                          <div class="w-100 ml-3 td-row-space">
                            <ValidationProvider
                              v-slot="{ errors }"
                              :name="'selectedAgency' + index"
                              rules="required"
                            >
                              <CustomDropDown
                                v-model="agency.invitationRazon"
                                placeholder="Razón Invitación de Agencia"
                                required
                                :disabled="isReadonlyWithAmendment"
                                fieldkey="id"
                                fieldname="name"
                                :options="agencyInvitationRazonList"
                                :error="errors[0]"
                                :custom-error-msg="resources['9052']"
                                @input="invitationChanged($event, agency.id)"
                              />
                            </ValidationProvider>
                          </div>
                          <div class="w-100 mt-3 ml-3 td-row-space">
                            <CustomInput
                              v-model="agency.contactSecondLastName"
                              label="Segundo Apellido Contacto (No es requerido)"
                              placeholder="Escribir segundo apellido"
                              :disabled="isReadonlyWithAmendment"
                              @input="
                                changeContactSecondLastName($event, agency)
                              "
                            />
                          </div>
                        </td>
                        <td class="col-md-2">
                          <div class="mb-2">
                            <ValidationProvider
                              v-slot="{ errors }"
                              class="w-100"
                              name="wasInvited"
                              rules="required"
                            >
                              <CustomRadioGroup
                                v-model="agency.wasInvited"
                                :label="'¿Se invitó a participar del COMPU?'"
                                :name="'wasInvited' + index"
                                :options="radioButtonsOptions"
                                :error="errors[0]"
                                :custom-error-msg="resources['56']"
                                :is-inline="true"
                                :is-disabled="isReadonlyWithAmendment"
                                @input="wasInvitedRadioChange($event, agency)"
                              />
                            </ValidationProvider>
                          </div>
                          <div v-if="agency.wasInvited" class="mb-2">
                            <ValidationProvider
                              v-slot="{ errors }"
                              class="w-100"
                              name="participated"
                              rules="required"
                            >
                              <CustomRadioGroup
                                v-model="agency.participated"
                                :label="'¿Participó del COMPU?'"
                                :name="'participated' + index"
                                :options="radioButtonsOptions"
                                :error="errors[0]"
                                :custom-error-msg="
                                  'Favor seleccionar una opción.'
                                "
                                :is-inline="true"
                                :is-disabled="isReadonlyWithAmendment"
                                @input="participatedRadioChange($event, agency)"
                              />
                            </ValidationProvider>
                          </div>
                          <div v-if="agency.participated" class="col-12">
                            <ValidationProvider
                              v-slot="{ errors }"
                              :name="'participationAgency' + index"
                              rules="required"
                            >
                              <CustomDropDown
                                v-model="agency.participationType"
                                label
                                placeholder="Tipo de participación"
                                required
                                :disabled="isReadonlyWithAmendment"
                                fieldkey="id"
                                fieldname="name"
                                :options="participationTypeList"
                                :error="errors[0]"
                                :custom-error-msg="resources['R03200114']"
                                @input="changeParticipationType($event, agency)"
                              />
                            </ValidationProvider>
                          </div>
                        </td>
                        <td class="col-md-1 text-right">
                          <button
                            v-show="!isReadonlyWithAmendment"
                            class="btn btn-dropdown-actions dropdown-toggle pt-1"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            Acciones
                          </button>
                          <div
                            class="dropdown-menu dropdown-menu-right"
                            aria-labelledby="dropdownMenuLink"
                          >
                            <button
                              class="dropdown-item"
                              @click="DeleteAgency(agency, index)"
                            >
                              <span class="fas fa-times-circle text-red pr-1" />
                              Eliminar
                            </button>
                          </div>
                        </td>
                        <td class="col-md-12 text-right no-border-top">
                          <div
                            v-if="
                              agency &&
                                agency.invitationRazon &&
                                agency.invitationRazon.id ===
                                  invitationReasonTypeOther
                            "
                            class="form-group w-100 mb-neg-4 ml-3"
                          >
                            <ValidationProvider
                              v-slot="{ errors, dirty }"
                              class="w-100"
                              name="invitationRezonWithDescription"
                              :rules="
                                `${showRazonComment + index ? 'required' : ''}`
                              "
                            >
                              <CustomTextArea
                                v-model="agency.invitationReasonDescription"
                                placeholder="Escribir la descripción de la razon..."
                                :maxlength="500"
                                :disabled="isReadonlyWithAmendment"
                                :row="5"
                                required
                                :dirty="dirty"
                                :error="errors[0]"
                                :custom-error-msg="resources[9052]"
                              />
                            </ValidationProvider>
                          </div>
                        </td>
                        <td class="col-md-12 no-border-top">
                          <div class="w-100">
                            <ValidationProvider
                              v-slot="{ errors }"
                              class="w-100"
                              name="AdditionalManagement"
                              rules="required"
                            >
                              <CustomRadioGroup
                                v-model="agency.additionalManagement"
                                :label="
                                  '¿Se realizaron gestiones adicionales para garantizar la participación de otras agencias?'
                                "
                                :name="'AdditionalManagement' + index"
                                :options="radioButtonsOptions"
                                :error="errors[0]"
                                :custom-error-msg="resources[9053]"
                                :is-inline="true"
                                :is-disabled="isReadonlyWithAmendment"
                              />
                            </ValidationProvider>
                          </div>
                          <div class="w-100 ml-3">
                            <ValidationProvider
                              v-slot="{ errors }"
                              :name="'selectedAgency' + index"
                              rules="required"
                            >
                              <p>
                                {{
                                  agency.additionalManagement
                                    ? 'Gestiones Realizadas'
                                    : 'Comentario'
                                }}
                              </p>
                              <CustomTextArea
                                v-show="true"
                                v-model="agency.additionalManagementDescription"
                                placeholder="Descripcion..."
                                :maxlength="500"
                                :disabled="isReadonlyWithAmendment"
                                :row="5"
                                required
                                :dirty="dirty"
                                :error="errors[0]"
                                :custom-error-msg="resources[9052]"
                              />
                            </ValidationProvider>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="agencies.length > 0" class="w-100 text-right">
                  <ActionButton
                    v-show="!isReadonlyWithAmendment"
                    variant="success"
                    i="fas fa-file-plus"
                    @click="AddAgency"
                  >
                    Añadir
                  </ActionButton>
                </div>
                <div
                  v-if="agencies.length == 0 && isDraft"
                  class="w-100 d-flex justify-content-center"
                >
                  <BoxIconButton
                    v-if="canEditTab9"
                    class="w-50 mb-4"
                    title="Presione aquí para añadir la agencia"
                    icon="fas fa-file-plus"
                    :disabled="isReadonlyWithAmendment"
                    @click="AddAgency"
                  />
                </div>
              </div>
              <div style="clear: both;" />
              <SectionTitle
                v-if="!isPs && !isPSC"
                :has-line="true"
                content="B. Describa la participación de la familia en el desarrollo de las actividades recomendadas"
                container-class="mb-4"
              />
              <div class="form-group w-100 mb-neg-4">
                <ValidationProvider
                  v-slot="{ errors, dirty }"
                  class="w-100"
                  name="familyParticipationAct"
                  immediate
                  :rules="`${ValidationTriggered.validation ? 'required' : ''}`"
                >
                  <CustomTextArea
                    v-show="true"
                    v-model="modelInfo.familyParticipationAct"
                    placeholder="Escribir participación de la familia..."
                    :maxlength="3000"
                    :disabled="isReadonlyWithAmendment"
                    :row="5"
                    required
                    :dirty="dirty"
                    :error="errors[0]"
                    :custom-error-msg="resources[9005]"
                  />
                </ValidationProvider>
              </div>
            </div>
            <SectionTitle
              v-if="!isPs && !isPSC"
              icon="fas fa-file-user"
              content="X. Describa la manera en que se informará a los padres sobre el progreso del estudiante"
              container-class="tag-badge-main-info mt-4 mb-4"
            />

            <Error
              v-if="controversyX && controversyX.existControversy"
              is-alert-mode
              :message="
                '<b>Parte en Controversia: </b>' +
                  controversyX.informationMessage
              "
            />

            <SectionTitle
              v-if="isPs && !isPSC"
              icon="fas fa-file-user"
              content="VIII. Describa la manera en que se informará a los padres sobre el progreso del estudiante"
              container-class="tag-badge-main-info mt-4 mb-4"
            />
            <div v-if="!isPSC" class="col-12 pl-0 pr-0 mb-neg-35">
              <div class="form-group mt-2 pb-4 w-100">
                <ValidationProvider
                  v-slot="{ errors, dirty }"
                  class="w-100"
                  name="familyProgressAct"
                  :rules="`${ValidationTriggered.validation ? 'required' : ''}`"
                >
                  <CustomTextArea
                    v-show="true"
                    v-model="modelInfo.familyProgressAct"
                    placeholder="Escribir manera de informar progreso..."
                    :maxlength="3000"
                    :row="5"
                    :disabled="isReadonlyWithAmendment"
                    required
                    :dirty="dirty"
                    :error="errors[0]"
                    :custom-error-msg="resources[8014]"
                  />
                </ValidationProvider>
              </div>
            </div>
            <SectionTitle
              v-if="!isPs && !isPSC"
              icon="fas fa-user-edit"
              content="XI. Fecha de revisión del PEI o PS"
              container-class="tag-badge-main-info mt-4 mb-4"
            />

            <Error
              v-if="controversyXI && controversyXI.existControversy"
              is-alert-mode
              :message="
                '<b>Parte en Controversia: </b>' +
                  controversyXI.informationMessage
              "
            />

            <SectionTitle
              v-if="isPs && !isPSC"
              icon="fas fa-user-edit"
              content="IX. Fecha de revisión del PEI o PS"
              container-class="tag-badge-main-info mt-4 mb-4"
            />
            <div v-if="!isPSC" class="col-12 pl-0 pr-0 mt-neg-16">
              <div class="mb-4 col-3 pl-0">
                <ValidationProvider
                  v-slot="{ errors }"
                  class="w-100"
                  name="Fecha de Revisión"
                  immediate
                  :rules="`${ValidationTriggered.validation ? 'required' : ''}`"
                >
                  <CustomDatePicker
                    v-model="modelInfo.revisionDate"
                    placeholder
                    :disabled="isReadonlyWithAmendment"
                    format="dd/MMM./yyyy"
                    :error="errors[0]"
                    :custom-error-msg="resources[9007]"
                  />
                </ValidationProvider>
              </div>
            </div>
            <SectionTitle
              v-if="!isPs && !isPSC"
              icon="fas fa-share-all"
              content="XII. Transferencia de derechos"
              container-class="tag-badge-main-info mt-2 mb-4"
            />

            <Error
              v-if="controversyXII && controversyXII.existControversy"
              is-alert-mode
              :message="
                '<b>Parte en Controversia: </b>' +
                  controversyXII.informationMessage
              "
            />

            <div v-if="!isPs && !isPSC" class="col-12 pl-0 pr-0">
              <Error
                v-if="isAdult && isDraft"
                is-alert-mode
                class=" pl-3"
                :message="
                  'El estudiante tendrá 21 años o más durante la implementación de este PEI por lo que se recomienda realizar la transferencia de derechos.'
                "
              />

              <div class="col-12 bold">
                Declaración de transferencia de derechos al estudiante, al este
                alcanzar la mayoría de edad, de acuerdo a la Ley Estatal. (Se
                requiere que se notifique al estudiante un año antes de que
                cumpla la mayoría de edad) ¿El estudiante certifica que ha sido
                informado sobre los derechos que se le transfieren al cumplir la
                mayoría de edad, bajo la Ley Estatal vigente?
              </div>
              <div class="col-12 mt-2 pl-0 pr-0">
                <ValidationProvider
                  v-slot="{ errors, dirty }"
                  class="w-100"
                  name="Transferencia de Derechos"
                  immediate
                  :rules="
                    `${
                      validationTriggered.validation &&
                      modelInfo.studentRight == null
                        ? 'required'
                        : ''
                    }`
                  "
                >
                  <CustomRadioGroup
                    v-model="modelInfo.studentRight"
                    id="studentRight"
                    name="studentRight"
                    :options="studentRightOptions"
                    :dirty="dirty"
                    :is-disabled="isReadonlyWithAmendment"
                    :error="errors[0]"
                    :custom-error-msg="resources['R03200130']"
                    :is-inline="true"
                  />
                </ValidationProvider>
              </div>
            </div>
            <SectionTitle
              v-if="!isPs"
              icon="fas fa-pen-nib"
              content="XIII. Firma de los miembros del Comité de Programación y Ubicación"
              container-class="tag-badge-main-info mt-4 mb-2"
            />

            <Error
              v-if="controversyXIII && controversyXIII.existControversy"
              is-alert-mode
              :message="
                '<b>Parte en Controversia: </b>' +
                  controversyXIII.informationMessage
              "
            />

            <SectionTitle
              v-if="isPs"
              icon="fas fa-pen-nib"
              content="X. Firma de los miembros del Comité de Programación y Ubicación"
              container-class="tag-badge-main-info mt-5 mb-4"
            />

            <Error
              v-if="hasCompuP9ExError"
              message="Según el tipo de participación establecido no se llevó a cabo una reunión de COMPU."
            />
            <div v-if="validPlacement || !isDraft" class="col-12 pl-0 pr-0">
              <ParticipantSignatures
                ref="ParticipantSignatures"
                :key="componentKey"
                :value="signatureList"
                :options="availableSignatureOptions"
                :participation-types="participationTypeList"
                :alternate-participations="alternateParticipationTypeList"
                :is-draft="!isReadonlyWithAmendment"
                :info-message="signatureInfoMessage"
                :fullname-only="false"
                @addSignature="addSignature()"
                @deleteSignature="deleteSignature"
              />
            </div>
            <div v-else>
              <Error
                class=" pl-3"
                message="Para visualizar el área de Firmas debe seleccionar una alternativa de ubicación en la parte VIII.A del PEI. "
              />
            </div>
          </form>
        </SaveObserver>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import { SectionTitle } from '@/components/pei/shared';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import SaveObserver from '@/components/common/SaveObserver';
import CustomDatePicker from '@/components/common/CustomDatePicker';
import CustomInput from '@/components/common/CustomInput';
import CustomTextArea from '@/components/common/CustomTextArea';
import CustomDropDown from '@/components/common/CustomDropDown';
import CustomRadioGroup from '@/components/common/CustomRadio';
import Error from '@/components/common/Error';
import store from '@/store/index';
import mixAlert from '@/mixin/alert.mixin';
import resourcesService from '@/services/resources.js';
import ParticipantSignatures from '@/components/pei/tabs/components/Tab9/participantSignatures/Tab9ParticipantSignatures';
import '@/assets/css/component/radio-button.css';
import peiSections from '@/utils/constants/pei/peiSections.js';
import peiStatuses from '@/utils/constants/pei/peiStatus';
import ActionButton from '../../common/ActionButton';
import BoxIconButton from '@/components/pei/shared/BoxIconButton';
import signatureService from '@/modules/common/signature.api';

const ADULT_AGE = 21;
const SUB_SECTION_A = 45;
const SUB_SECTION_B = 46;

export default {
  name: 'Tab9',
  mixins: [mixAlert],
  components: {
    SaveObserver,
    SectionTitle,
    CustomDatePicker,
    CustomInput,
    CustomTextArea,
    CustomDropDown,
    ValidationProvider,
    ValidationObserver,
    Error,
    ParticipantSignatures,
    CustomRadioGroup,
    ActionButton,
    BoxIconButton,
  },
  data() {
    return {
      showCommentForAgencyIds: [],
      Info: {},
      isPs: store.state.pei.configUnilateralFlag == '1',
      isPSC: store.state.pei.configUnilateralFlag == '2',
      peiStatus: store.getters.SelectedPeiStatus,
      peiStatuses: peiStatuses,
      disabledDatesFrom: new Date(),
      errorMessage: '',
      resources: [],
      isCurrentStepValid: true,
      isCurrentStepValidProgress: true,
      peiId: store.getters.SelectedPei,
      selectedStudent: store.getters.SelectedStudent,
      currentPeiStatus: store.getters.SelectedPeiStatus,
      modelInfo: {
        PeiId: null,
        agencies: [],
        familyParticipationAct: '',
        familyProgressAct: '',
        revisionDate: null,
        studentRight: null,
        signatures: [],
      },
      places: [
        { signatureGroupId: 1 },
        { signatureGroupId: 5 },
        { signatureGroupId: 6 },
      ],
      attendanceArea: 381,
      agencyList: [],
      agencyInvitationRazonList: [],
      participationTypeList: [],
      alternateParticipationTypeList: [],
      agencies: [],
      signatures: [],
      componentKey: 0,
      studentRightOptions: [
        { label: 'Si', value: '1' },
        { label: 'No', value: '0' },
      ],
      radioButtonsOptions: [
        { label: 'Sí', value: true },
        { label: 'No', value: false },
      ],
      showFooterBar: false,
      prevScrollpos: window.pageYOffset,
      getParticipantSignatures: false,
      observers: {},
      signatureList: [],
      signatureCounter: 0,
      availableSignatureOptions: [],
      tabEntrys: 0,
      agencyCounter: 0,
      canEditTab9: store.getters.HasPermission('pei.editTab9'),
      validPlacement: false,
      signatureInfoMessage: '',
      invitationRezonWithDescription: { other: 8 },
      showRazonComment: false,
    };
  },
  methods: {
    invitationChanged(value, agencyId) {
      if (value && value.id > 0 && agencyId) {
        var agencyFound = this.showCommentForAgencyIds.find(
          (id) => id === agencyId
        );
        if (value.id === this.invitationReasonTypeOther && !agencyFound) {
          this.showCommentForAgencyIds.push(agencyId);
        } else if (agencyFound) {
          this.showCommentForAgencyIds = this.showCommentForAgencyIds.filter(
            (id) => id !== agencyId
          );
        }
      }
    },
    async getTabInfo() {
      let self = this;
      await self
        .$ApiGet('/api/pei/familyagenciestab?peiId=' + self.peiId)
        .then((res) => {
          self.modelInfo = res.data;

          if (self.modelInfo.revisionDate) {
            self.modelInfo.revisionDate = new Date(self.modelInfo.revisionDate);
          } else {
            self.modelInfo.revisionDate = new Date();
          }

          //*****signature Management********

          this.setSignatureConfig();

          if (self.modelInfo.agencies.length > 0) {
            self.modelInfo.agencies.forEach((agency) => {
              agency.selectedAgency = self.agencyList.find(
                (x) => x.id == agency.id
              );
              agency.participationType = self.participationTypeList.find(
                (x) => x.id == agency.participationType
              );
              agency.invitationRazon = self.agencyInvitationRazonList.find(
                (x) => x.id == this.getInvitationReasonIdFromAgencyObj(agency)
              );
              agency.invitationRazon = self.agencyInvitationRazonList.find(
                (x) => x.id == this.getInvitationReasonIdFromAgencyObj(agency)
              );
            });
            self.agencies = self.modelInfo.agencies;
          }

          if (!self.modelInfo.familyProgressAct) {
            self.validateFamilyParticipationAct();
          }
          this.callValidation();
        })
        .catch((err) => {
          self.response = err;
        });
    },
    // JSF: This must be removed ASAP when someone refactors this file.
    // this is a force because Im not sure which one is the true name for agency object
    getInvitationReasonIdFromAgencyObj(agency) {
      // I have no idea which one is the real deal.
      // other thing is their names are not well written...
      // in javascript we use camelCase and Razon is spelled "reason"
      // Please do not use both language at the same time. Either is in SPA or ENG.
      // Recommended ENG.
      const id = agency?.InvitationReasonId ?? agency?.invitationRazon?.id;

      // Please don't kill me... I swear it comes with 3 different names for the same prop.
      // it was exploting 3 time with different name.. This method fix it.
      return id ?? agency?.invitationReasonId;
    },
    async setSignatureConfig() {
      await this.validatePlacementInfo();
      if (this.validPlacement != true && this.isDraft) {
        return;
      }

      let signatureConfig = [];
      await signatureService
        .getDefaultConfiguration(this.peiId, this.selectedStudent.studentId)
        .then((result) => {
          signatureConfig = result.data;
        });
      this.signatureList = [];
      if (signatureConfig.length > 0) {
        this.signatureInfoMessage = signatureConfig.find(
          (e) => e.name != ''
        )?.name;
        signatureConfig.forEach((config) => {
          let signature = this.getBasicSignature(config.id, config.value);
          if (signature != undefined) {
            this.signatureList.push(signature);
          }
        });
      } else {
        this.signatureList = [];
        //getting default Signatures
        let signature1 = this.getBasicSignature(1);
        if (signature1 != undefined) {
          this.signatureList.push(signature1);
        }

        let signature5 = this.getBasicSignature(5);
        if (signature5 != undefined) {
          this.signatureList.push(signature5);
        }

        let signature6 = this.getBasicSignature(4);
        if (signature6 != undefined) {
          this.signatureList.push(signature6);
        }
      }
      this.loadSignatures();
    },
    validateFamilyParticipationAct() {
      this.modelInfo.familyProgressAct = this.isPs
        ? this.resources['PEI1002']
        : this.resources['PEI1001'];
    },
    addParticipationFaClicked() {
      //Validation of required
      this.isCurrentStepValid =
        this.modelInfo.familyPartipationAct &&
        this.modelInfo.familyPartipationAct != '';
      this.isCurrentStepValidProgress =
        this.modelInfo.familyProgressAct &&
        this.modelInfo.familyProgressAct != '';
    },
    AddAgency() {
      this.agencyCounter -= 1;
      this.agencies.push({
        id: this.agencyCounter,
        selectedAgency: null,
        invitationRazon: null,
        contactName: '',
        providedService: '',
        wasInvited: null,
        participated: null,
        participationType: null,
      });
      if (store.getters.getPeiValidationTriggered.validation) {
        this.$refs.formValidator.validate();
      }
    },
    async getAgencyList() {
      await this.$ApiGet('/api/pei/agencyList')
        .then((res) => {
          this.agencyList = res.data;
        })
        .catch((err) => {
          this.response = err;
        });
    },
    async getAgencyInvitationRazonList() {
      await this.$ApiGet('/api/pei/agencyinvitationreasonlist')
        .then((res) => {
          this.agencyInvitationRazonList = res.data;
        })
        .catch((err) => {
          this.response = err;
        });
    },
    async getParticipationTypeList() {
      await this.$ApiGet('/api/pei/participationTypeList')
        .then((res) => {
          this.participationTypeList = res.data;
        })
        .catch((err) => {
          this.response = err;
        });
    },
    async getAlternateParticipationTypeList() {
      await this.$ApiGet('/api/pei/alternateParticipationTypeList')
        .then((res) => {
          this.alternateParticipationTypeList = res.data;
        })
        .catch((err) => {
          this.response = err;
        });
    },
    getLinkedASignature(agency) {
      if (agency.id == 0 && agency.selectedAgency == null) return null;

      let agencyId =
        agency.selectedAgency && agency.selectedAgency !== undefined
          ? agency.selectedAgency.id
          : agency.id;

      let Signature = this.signatureList.find((x) =>
        x.agency !== undefined && x.agency.selectedAgency !== undefined
          ? x.agency.selectedAgency.id == agencyId
          : x.agency !== undefined && x.agency.id == agencyId
      );

      let SignatureIndex = this.signatureList.findIndex((x) =>
        x.agency !== undefined && x.agency.selectedAgency !== undefined
          ? x.agency.selectedAgency.id == agencyId
          : x.agency !== undefined && x.agency.id == agencyId
      );
      return {
        Signature,
        SignatureIndex,
      };
    },
    async DeleteAgency(agency, index) {
      let linkedSignature = this.getLinkedASignature(agency);
      if (linkedSignature && linkedSignature.Signature) {
        this.deleteSignature(linkedSignature.Signature.id);
      }
      this.agencies.splice(index, 1);
    },
    async changeContactName(event, agency) {
      let linkedSignature = this.getLinkedASignature(agency);
      if (linkedSignature && linkedSignature.Signature) {
        linkedSignature.Signature.signature.name = event;
      }
    },
    async changeContactFirstLastName(event, agency) {
      let linkedSignature = this.getLinkedASignature(agency);
      if (linkedSignature && linkedSignature.Signature) {
        linkedSignature.Signature.signature.paternalName = event;
      }
    },
    async changeContactSecondLastName(event, agency) {
      let linkedSignature = this.getLinkedASignature(agency);
      if (linkedSignature && linkedSignature.Signature) {
        linkedSignature.Signature.signature.maternalName = event;
      }
    },
    async wasInvitedRadioChange(event, agency) {
      if (event == false) {
        let linkedSignature = this.getLinkedASignature(agency);
        if (linkedSignature && linkedSignature.Signature) {
          this.deleteSignature(linkedSignature.Signature.id);
        }
      }
      agency.participated = null;
      agency.participationType = null;
    },
    async participatedRadioChange(event, agency) {
      if (event == false) {
        let linkedSignature = this.getLinkedASignature(agency);
        if (linkedSignature && linkedSignature.Signature) {
          this.deleteSignature(linkedSignature.Signature.id);
        }
      }
      agency.participationType = null;
    },
    async changeParticipationType(event, agency) {
      const selectedValue = event ? event.id : null;
      let linkedSignature = this.getLinkedASignature(agency);
      if (selectedValue != null) {
        if (linkedSignature && linkedSignature.Signature) {
          linkedSignature.Signature.signature.participationId = this.participationTypeList.find(
            (e) => e.id == selectedValue
          );
          linkedSignature.Signature.signature.alternateId = undefined;
        } else {
          this.addAgencySignature(agency, selectedValue);
        }
      } else {
        this.deleteSignature(linkedSignature.Signature.id);
      }
    },
    async changeAgency(event, agency) {
      const self = this;
      let linkedSignature = self.getLinkedASignature(agency);
      if (linkedSignature && linkedSignature.Signature) {
        linkedSignature.Signature.agency = agency;
      }
    },
    async updatePeiAgenciesSignature() {
      let self = this;
      return await new Promise((resolve) => {
        self
          .$ApiPost('/api/pei/familyagenciestab', self.modelInfo)
          .then((res) => {
            if (res && res.data != null) {
              resolve(res.data);
              this.ShowToast(
                this.resources['R03200110'],
                this.resources['R03200109'],
                'success'
              );
            }
          })
          .catch(function(err) {
            self.ShowToast(
              err.message,
              'Ha ocurrido un error mientras se procesaba la información.',
              'error'
            );
          });
      });
    },
    async agenciesDTOTransformations(signatures) {
      this.modelInfo.agencies = [];
      this.modelInfo.signatures = [];
      this.modelInfo.PeiId = this.$store.getters.SelectedPei;
      this.agencies.forEach((agency) => {
        this.modelInfo.agencies.push({
          id: agency.selectedAgency.id,
          participationType: agency.participationType
            ? agency.participationType.id
            : null,
          contactName: agency.contactName,
          contactFirstLastName: agency.contactFirstLastName,
          contactSecondLastName: agency.contactSecondLastName,
          wasInvited: agency.wasInvited,
          participated: agency.participated,
          providedService: agency.providedService,
          InvitationReasonId: this.getInvitationReasonIdFromAgencyObj(agency),
          InvitationReasonDescription: agency.invitationReasonDescription,
          AdditionalManagement: agency.additionalManagement,
          AdditionalManagementDescription:
            agency.additionalManagementDescription,
        });
      });
      if (signatures != null) {
        signatures.forEach((signature, index) => {
          if (signature.positionId != null) {
            this.modelInfo.signatures.push({
              positionCode: signature.positionId,
              fullname: '',
              firstName: signature.name,
              paternalName: signature.paternalName,
              maternalName: signature.maternalName,
              isAgency: signature.agency ? true : false,
              participationTypeId: signature.participationType,
              alternateParticipationTypeId:
                signature.alternateParticipationType,
              participationAgencyId: signature.agency
                ? signature.agency.selectedAgency.id
                : null,
              index: index,
            });
          }
        });
      }
    },
    // Save.
    async save() {
      await this.handleSubmit();
    },
    async handleSubmitFake() {},
    async handleSubmit() {
      let isValid = await this.$refs.formValidator.validate();
      if (!isValid && !this.validationTriggered.validation) {
        return;
      }
      //map with signatures
      let participantSignatures = this.getSignatureList();
      await this.agenciesDTOTransformations(
        JSON.parse(JSON.stringify(participantSignatures))
      );

      await this.updatePeiAgenciesSignature();
      store.commit('setFormDirty', { value: false });
      await this.getTabInfo();
      if (this.validationTriggered.validation) {
        await this.$refs.formValidator.validate();
      }
    },
    // Event handlers.
    // Getting data from ParticipantSignatures component.
    async gettingParticipantSignatures(data) {
      this.getParticipantSignatures = false;
      return this.agenciesDTOTransformations(JSON.parse(JSON.stringify(data)));
    },
    // Get observers.
    async getObserver(id, observer) {
      this.observers = {
        ...this.observers,
        [id]: observer,
      };
    },
    // Resources.
    async loadResources() {
      let resourceCodes = [
        '9005',
        '8014',
        '9007',
        'PEI1001',
        'PEI1002',
        '9001',
        '9002',
        '9003',
        '9009',
        'R03200114',
        '56',
        'R03200130',
        'R03200110',
        'R03200109',
        '9051',
        '9052',
        '9053',
      ];

      this.resources = await resourcesService.LoadValidationMessages(
        resourceCodes
      );
    },
    avaliableAgencyListComputed() {
      let agencyListComputed = [];
      for (let i = 0; i < this.agencyList.length; i++) {
        if (
          !this.agencies.find(
            (x) =>
              x.selectedAgency != null &&
              x.selectedAgency.id == this.agencyList[i].id
          )
        ) {
          agencyListComputed.push(this.agencyList[i]);
        }
      }
      return agencyListComputed;
    },
    async getAvailableSignatureOptions() {
      let self = this;
      let promise = new Promise((resolve) => {
        self.$ApiGet('/api/signature/availablepositionsTab9').then((res) => {
          self.availableSignatureOptions = res.data;
          resolve(res.data);
        });
      });

      return promise;
    },
    addSignature() {
      this.signatureCounter -= 1;
      this.signatureList.push({
        id: this.signatureCounter,
        signature: {
          name: '',
          paternalName: '',
          maternalName: '',
          positionId: undefined,
          participationId: undefined,
          alternateId: undefined,
        },
        groupId: 0,
        isRequired: this.ValidationTriggered.validation,
        isRemovable: true,
        isDraft: this.isDraft,
        isDisabled: !this.isDraft,
      });
    },
    async deleteSignature(id) {
      let signature = this.signatureList.find((e) => e.id === id);

      if (signature != null && signature.isBasic == true) {
        await signatureService.removeFromDefaults(
          signature.groupId,
          this.peiId
        );
      }
      let signatureListIndex = this.signatureList.findIndex((e) => e.id === id);
      this.signatureList.splice(signatureListIndex, 1);
    },
    getBasicSignature(groupId, removable = false) {
      let signature = this.modelInfo.signatures.find((x) =>
        this.availableSignatureOptions.some(
          (y) =>
            y.signatureGroupId == groupId &&
            y.signaturePositionId == x.positionCode
        )
      );
      if (signature != undefined) {
        return {
          id: signature.id,
          signature: {
            name: !this.isDraft ? signature.fullName : signature.firstName,
            paternalName: signature.paternalName,
            maternalName: signature.maternalName,
            positionId: { signaturePositionId: signature.positionCode },
            participationId: { id: signature.participationTypeId },
            alternateId: { id: signature.alternateParticipationTypeId },
          },
          groupId: groupId,
          isRequired: this.ValidationTriggered.validation,
          isRemovable: removable,
          isDraft: this.isDraft,
          isDisabled: !this.isDraft,
          isBasic: true,
        };
      } else {
        if (this.isDraft) {
          this.signatureCounter -= 1;
          return {
            id: this.signatureCounter,
            signature: {
              name: '',
              paternalName: '',
              maternalName: '',
              positionId: undefined,
              participationId: undefined,
              alternateId: undefined,
            },
            groupId: groupId,
            isRequired: this.ValidationTriggered.validation,
            isRemovable: removable,
            isBasic: true,
          };
        }
      }
    },
    loadSignatures() {
      let self = this;
      this.modelInfo.signatures.forEach((signature) => {
        if (!self.signatureList.some((x) => x.id == signature.id)) {
          self.signatureList.push({
            id: signature.id,
            signature: {
              name: !this.isDraft ? signature.fullName : signature.firstName,
              paternalName: signature.paternalName,
              maternalName: signature.maternalName,
              positionId: { signaturePositionId: signature.positionCode },
              participationId: { id: Number(signature.participationTypeId) },
              alternateId: { id: signature.alternateParticipationTypeId },
            },
            groupId: 0,
            isRequired: self.ValidationTriggered.validation,
            agency: signature.participationAgencyId
              ? { selectedAgency: { id: signature.participationAgencyId } }
              : undefined,
            isRemovable: signature.participationAgencyId ? false : true,
            isDisabled: !self.isDraft ? true : false,
            nameDisabled: signature.participationAgencyId ? true : false,
            participationDisabled: signature.participationAgencyId
              ? true
              : false,
            positionDisabled: signature.participationAgencyId ? true : false,
            isDraft: self.isDraft,
          });
        }
      });
    },
    getSignatureList() {
      let self = this;
      let signatures = [];
      self.signatureList.forEach((x) => {
        let signInfo = {
          name: x.signature.name,
          paternalName: x.signature.paternalName,
          maternalName: x.signature.maternalName,
          positionId: x.signature.positionId?.signaturePositionId,
          participationType: x.signature.participationId?.id,
          alternateParticipationType: x.signature.alternateId
            ? x.signature.alternateId.id
            : undefined,
          agency: x.agency,
        };
        signatures.push(signInfo);
      });
      return signatures;
    },
    addAgencySignature(agency, participationType) {
      this.signatureCounter -= 1;
      this.signatureList.push({
        id: this.signatureCounter,
        signature: {
          name: agency.contactName,
          paternalName: agency.contactFirstLastName,
          maternalName: agency.contactSecondLastName,
          positionId: { signaturePositionId: 849 },
          participationId: { id: participationType },
          alternateId: undefined,
        },
        groupId: 0,
        isRequired: false,
        agency: agency,
        isRemovable: false,
        isDisabled: false,
        positionDisabled: true,
        participationDisabled: true,
        nameDisabled: true,
      });
    },
    async validatePlacementInfo() {
      await this.$ApiGet(`/api/pei/${this.peiId}/validatePlacementInfo`)
        .then((res) => {
          this.validPlacement = res.data;
        })
        .catch((err) => {
          this.response = err;
        });
    },
    async callValidation() {
      if (store.getters.getPeiValidationTriggered.validation) {
        await this.$refs.formValidator.validate();
      }
    },
  },
  computed: {
    isReadonlyWithAmendment() {
      if (!this.canEditTab9) {
        return true;
      }
      if (this.isDraft) {
        return false;
      }
      return !(this.canUseTabEditRestriction && !this.amendantIsEmpty);
    },
    controversyIX() {
      return store.getters.getPeiControversies(peiSections.IX);
    },
    controversyX() {
      return store.getters.getPeiControversies(peiSections.X);
    },
    controversyXI() {
      return store.getters.getPeiControversies(peiSections.XI);
    },
    controversyXII() {
      return store.getters.getPeiControversies(peiSections.XII);
    },
    controversyXIII() {
      return store.getters.getPeiControversies(peiSections.XIII);
    },
    isDraft() {
      return store.getters.SelectedPeiStatus == peiStatuses.Borrador;
    },
    ValidationTriggered() {
      return store.getters.getPeiValidationTriggered;
    },
    invitationReasonTypeOther() {
      return 8;
    },
    isAdult() {
      return store.getters.getPeiInfo.ageAmt >= ADULT_AGE;
    },
    validationTriggered() {
      return store.getters.getPeiValidationTriggered;
    },
    hasCompuP9ExError() {
      const tab9Errors = this.validationTriggered.tabValidation?.find(
        (x) => x.id == 'Tab9'
      )?.errors;
      return (tab9Errors || []).some((e) =>
        String(e.id).startsWith('COMPU-P9EX')
      );
    },
    canUseTabEditRestriction() {
      return (
        this.$store.state['$_admendment'].correlationParameter[0]
          .staticValue === 'true'
      );
    },
    hasSectionXinAmendant() {
      return this.$store.state['$_admendment'].sections.some(
        (x) => x.sectionId == parseInt(peiSections.X)
      );
    },
    hasSectionXIinAmendant() {
      return this.$store.state['$_admendment'].sections.some(
        (x) => x.sectionId == parseInt(peiSections.XI)
      );
    },
    hasSectionXIIinAmendant() {
      return this.$store.state['$_admendment'].sections.some(
        (x) => x.sectionId == parseInt(peiSections.XII)
      );
    },
    hasSectionXIIIinAmendant() {
      return this.$store.state['$_admendment'].sections.some(
        (x) => x.sectionId == parseInt(peiSections.XIII)
      );
    },
    hasSubSectionAinAmendantIX() {
      return this.$store.state['$_admendment'].sections.some(
        (x) => x.subSectionId == SUB_SECTION_A
      );
    },
    hasSubSectionBinAmendantIX() {
      return this.$store.state['$_admendment'].sections.some(
        (x) => x.subSectionId == SUB_SECTION_B
      );
    },
    amendantIsEmpty() {
      return this.$store.state['$_admendment'].sections.length == 0;
    },
  },
  async activated() {
    this.$store.commit('setSaveBtnVisibility', false);
    this.$store.commit('setSaveMethod', () => {
      this.handleSubmit();
    });
    this.$store.commit('setResetOriginalDataMethod', () => {});
    if (this.tabEntrys > 0) {
      this.getTabInfo();
    }
    this.tabEntrys += 1;
  },
  async mounted() {
    this.Info = this.$attrs.Info;
    await this.loadResources();
    await this.getAvailableSignatureOptions();
    await this.getParticipationTypeList();
    await this.getAlternateParticipationTypeList();
    await this.getAgencyInvitationRazonList();

    await this.getAgencyList();
    await this.getTabInfo();
    this.callValidation();
  },
};
</script>

<style scoped>
.info-tab p {
  text-align: left;
  font: Bold 14px/17px Lato;
  color: #727272;
  opacity: 1;
}
.main-content {
  margin: 0px;
  padding: 0px;
}
.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 700;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
  width: 7.8125rem;
  height: 2.25rem;
}
.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}
.text-bold {
  font-weight: 600 !important;
}
.content-table-striped {
  margin-top: 0px;
}
.td-row-space {
  width: 90% !important;
}
.footer-success {
  margin: 8px;
  padding: 5px 10px;
}
.mt-neg-16 {
  margin-top: -16px !important;
}
.mb-neg-4 {
  margin-bottom: -4px !important;
}
.mb-neg-35 {
  margin-bottom: -35px !important;
}
.table-hover tbody tr:hover {
  color: #212529;
  background-color: rgba(0, 0, 0, 0);
}
.no-border-top {
  border-top: none !important;
}
</style>
